var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalSatelliteSystem01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,8.57c-2.67,0-7.19-0.32-7.19-1.51c0-1.2,4.7-1.51,7.19-1.51s7.19,0.32,7.19,1.51 C15.19,8.25,10.67,8.57,8,8.57z M8,6.05c-4.24,0-6.61,0.66-6.69,1.01C1.39,7.41,3.76,8.07,8,8.07s6.61-0.66,6.69-1.01 C14.61,6.71,12.24,6.05,8,6.05z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.82,12.93c-0.82,0-1.94,0-1.94-1.71v-0.25h3.9v0.25C9.78,12.93,9.05,12.93,7.82,12.93z M6.39,11.47 c0.08,0.96,0.63,0.96,1.43,0.96c1.12,0,1.42,0,1.46-0.96H6.39z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,11.47c-3.96,0-7.19-1.98-7.19-4.41V6.91l6.28-3.23l1.92,0.03l6.18,3.2v0.15C15.19,9.49,11.96,11.47,8,11.47 z M1.32,7.21C1.45,9.3,4.4,10.97,8,10.97s6.55-1.67,6.68-3.76L8.84,4.18H7.15L1.32,7.21z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 3.93,
    className: "st2",
    width: 0.5,
    height: 4.39
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalSatelliteSystem01);
export default __webpack_public_path__ + "static/media/DigitalSatelliteSystem-01.d1a3e77175be80ea56351dc7cbefcbd2.svg";
export { ForwardRef as ReactComponent };